module.exports = __webpack_public_path__ + "ci_vendor_jennifer.8e38b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_jennifer.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_jennifer.svg
// module chunks = main